import styled from 'styled-components'

interface InfoListType {
  label: string
  value: string
}

interface UserInfoTextLayoutMobileProps {
  title: string
  list: InfoListType[]
  className?: string
}

const UserInfoTextLayoutMobile = ({
  list,
  title,
  className,
}: UserInfoTextLayoutMobileProps) => {
  return (
    <StyledWrapper className={className}>
      <p>{title}</p>
      <ul>
        {list.map((item, index) => (
          <li key={`${item.label}-${index}`}>
            <div>
              <label>{item.label}</label>
              <p>{item.value} </p>
            </div>
          </li>
        ))}
      </ul>
    </StyledWrapper>
  )
}

export default UserInfoTextLayoutMobile

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > p {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -0.64px;
    text-align: left;
    color: #333;
  }

  > ul {
    display: flex;
    flex-direction: column;
    gap: 12px;
    > li {
      list-style: disc;
      list-style-position: inside;
      > div {
        display: inline;
        position: relative;

        > label {
          font-size: 15px;
          font-weight: 500;
          line-height: 1.47;
          letter-spacing: -0.6px;
          text-align: left;
          color: #333;
        }

        > p {
          position: absolute;
          width: max-content;
          top: 0px;
          left: 74px;
          font-size: 15px;
          font-weight: normal;
          line-height: 1.47;
          letter-spacing: -0.6px;
          text-align: left;
          color: #333;
        }
      }
    }
  }
`
